import { func, number, object, string } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { useCartState } from '../../contexts/cart';
import ExternalLink from '../../resources/images/external-link.svg';
import { getDirectionCTA } from '../checkoutv2/utils/editModuleFunctions';
import Button from '../global/atoms/button/button';
import { logError } from '../global/utils/logger';
import { dstDataLocators } from './dataLocators';
import useDst from './hooks/useDst';
import { useCheckUser } from '../../hooks/useCheckUser';
import { useFilterState } from '../cap';

const DstTrainerCard = ({
    item,
    setSelectedStoreValue,
    selectedStoreValue,
    cardRef,
    setZoomOutMax,
    userAddress,
    setFocusedLocation,
    handleViewMoreClick
}) => {
    const [{viewCart, projectDetails}, filterDispatch] = useFilterState();
    const { getTrainerSpecialtyObj, getDistanceText } = useDst();
    const intl = useIntl();
    const userType = useCheckUser()
    let phoneNo = item?.phoneNumber;

    const hrefPhone = `tel:${phoneNo}`;
    const hrefEmail = `mailto:${item?.email}`;
    const onClickGetDirections = () => {
        getDirectionCTA(item, {}, viewCart, userType, projectDetails, true, userAddress);
    };

    const onStoreClick = () => {
        setZoomOutMax(false);
        setFocusedLocation({ lat: item?.latitude, long: item?.longitude });
        setSelectedStoreValue(item?.pc);
    };
    const getStoreName = () => {
        return `${item?.firstName} ${item?.lastName}`;
    };

    const getTrainerSpecialty = () => {
        try {
            const specialityObj = getTrainerSpecialtyObj();
            let trainerSpecialty = '';
            const length = item?.qualifiedTrainingSet?.length;
            if (length > 1) {
                trainerSpecialty = `${specialityObj[item?.qualifiedTrainingSet?.[0]]}, ${
                    specialityObj[item?.qualifiedTrainingSet?.[1]]
                }`;
                if (length > 2) {
                    trainerSpecialty += ', ';
                }
            } else if (length == 1) {
                trainerSpecialty = `${specialityObj[item?.qualifiedTrainingSet?.[0]]}`;
            }
            return trainerSpecialty;
        } catch (error) {
            logError(error, false);
            return "";
        }
    };
    

    return (
        <div
            className={selectedStoreValue === item?.pc ? 'dst__card dst__card-selected' : 'dst__card'}
            onClick={onStoreClick}
            ref={cardRef}
            data-testid={dstDataLocators.dst_trainer_card}>
            <div className="dst__card-left">
                <div className="dst__card-left-storeDetail">
                    <div className="dst__card-left-top">
                        <div className="dst__card-title"> {getStoreName()}</div>
                        {item?.distance > 0 && (
                            <small className="dst__card-distance">
                                {Number(item?.distance).toFixed()} {getDistanceText()}
                            </small>
                        )}
                    </div>
                    {item?.qualifiedTrainingSet?.length > 0 && (
                        <div className="dst__card-trainingSet">
                            <small className="dst_card-trainingSpecialtyText">{getTrainerSpecialty()}</small>
                            {item?.qualifiedTrainingSet?.length > 2 && (
                                <>
                                    <Button
                                        className="dst__card-link dst__card-more-link"
                                        onClick={handleViewMoreClick}
                                        buttonAriaLabel={intl.formatMessage({ id: 'dts-trainer-view more' })}
                                        data-testid={dstDataLocators.dst_trainer_card_view_more}>
                                        {intl.formatMessage({ id: 'dst-card-view-text' })}{' '}
                                        {item?.qualifiedTrainingSet?.length - 2}{' '}
                                        {intl.formatMessage({ id: 'dst-card-more-text' })}
                                    </Button>
                                </>
                            )}
                        </div>
                    )}

                    <address
                        className="dst__card-address"
                        tabIndex={0}
                        aria-label={intl.formatMessage({ id: 'dts-trainer-address' })}>
                        <span className="dst__card-street">{`${item?.street?.toLowerCase()},`}</span>
                        <span>{`${item?.city?.toLowerCase()},`}</span>
                        <span>{`${item?.state}, ${item?.zip}`}</span>
                    </address>
                    <div className="dst__card-email">
                        <a
                            className="dst__card-link"
                            href={hrefEmail}
                            aria-label={intl.formatMessage({ id: 'dts-trainer-email' })}
                            data-testid={dstDataLocators.dst_trainer_card_email}>
                            {item?.email?.toLowerCase()}
                        </a>
                    </div>
                    <div className="dst__card-action">
                        <a
                            href={hrefPhone}
                            className="dst__card-link dst__card-call"
                            title={intl.formatMessage({ id: 'dts-trainer-phone-number' })}
                            data-testid={dstDataLocators.dst_trainer_card_phone}>
                            {phoneNo}
                        </a>
                        <Button
                            role="link"
                            onClick={onClickGetDirections}
                            className="dst__card-link dst__card-view-directions-wrap"
                            buttonAriaLabel={intl.formatMessage({ id: 'dts-trainer-view-google-map' })}
                            dataTestid={dstDataLocators.dst_trainer_card_get_directions}>
                            <ExternalLink tabIndex={'-1'} aria-hidden={true} />{' '}
                            {intl.formatMessage({ id: 'dst-card-view-directions' })}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

DstTrainerCard.propTypes = {
    item: object,
    setSelectedStoreValue: func,
    selectedStoreValue: number,
    setZoomOutMax: func,
    userAddress: string,
    setFocusedLocation: func,
    handleViewMoreClick: func
};

DstTrainerCard.defaultProps = {
    item: {},
    setSelectedStoreValue: () => {},
    selectedStoreValue: null,
    setZoomOutMax: () => {},
    userAddress: '',
    setFocusedLocation: () => {},
    handleViewMoreClick: () => {}
};

export default DstTrainerCard;
